<template>
  <div class="body" :style="{ backgroundImage: `url(${require('@/assets/flower-background.png')})` }">
    <div class="backdrop" />
    <div class="content d-flex flex-column justify-center align-center">
      <img :src="require('@/assets/CAVIN_Logo_white.png')" class ="mt-3" width="200px" />

      <span class="mt-3 welcome">{{ $t("welcome_back") }}</span>

      <v-card class="card d-flex flex-column justify-center align-center">
        <span class="card-title">{{ $t("login") }}</span>
        <p v-if="invalid" style="color: red;">{{ $t("login_error") }}</p>
        <div style="width: 100%;">
          <span class="label">{{ $t("email") }}</span>
          <v-text-field ref="email" type="text" v-model="content.email" @keyup="keyupHandler" :error="invalid" autofocus outlined />
        </div>

        <div class="mt-4" style="width: 100%;">
          <span class="label">{{ $t("password") }}</span>
          <v-text-field ref="password" :type="showPassword ? 'text' : 'password'" class="mb-0" v-model="content.password" @keyup="keyupHandler" outlined :error="invalid" />
        </div>

        <div class="checkbox">
          <v-checkbox :label="$t('show_pwd')" v-model="showPassword" class="ma-0" color="success" hide-details />
        </div>

        <div class="forgot_pwd">
          <span>{{ $t("forgot_pwd") }}</span>
          <router-link to="/forgot_pwd" class="link">{{ $t("here") }}</router-link>
        </div>

        <v-btn :class="`btn ${userType}`" @click="login">{{ $t("login_btn") }}</v-btn>
      </v-card>

      <div v-if="!disabledSignUp" class="signup">
        {{ $t("signup") }}
        <router-link :to="`/users/area`" class="link" style="color: white">{{ $t("here") }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: String,
  },
  data() {
    return {
      showPassword: false,
      invalid: false,
      content: {}
    };
  },
  async mounted() {
    this.$refs.email.focus();

    this.confirmationToken = this.$route.query.confirmation_token;

    if (this.confirmationToken) {
      const { result } = await this.$api.post(
        "/users/confirm",
        {
          user: {
            confirmation_token: this.confirmationToken
          }
        },
        {
          headers: {
            X_CLIENT_ID: process.env.VUE_APP_X_CLIENT_ID,
            X_CLIENT_SECRET: process.env.VUE_APP_X_CLIENT_SECRET
          }
        }
      );

      if (result.errors) {
        this.$router.push("/users/error");
      } else {
        this.$store.commit("setData", {
          is_confirmed: true
        });
      }
    }
  },
  computed: {
    userType() {
      const map = {
        Farm: "orange",
        Shop: "green",
        Driver: "pink",
      };
      return map[this.type];
    },
    disabledSignUp() {
      return this.type === "Driver";
    }
  },
  methods: {
    keyupHandler(e) {
      if (e.key === "Enter") this.login();
    },
    login() {
      const { email, password } = this.content;

      if (!email) {
        this.$refs.email.focus();
        return;
      }

      if (!password) {
        this.$refs.password.focus();
        return;
      }

      this.$store.dispatch("login", { email, password }).then(res => {
        if (res) {
          this.invalid = false;
          this.$router.push(`/${res.toLowerCase()}`);
        } else {
          this.invalid = true;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.body {
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  width: 100vw;
  height: 100vh;
}

.backdrop {
  background-color: #333333;
  opacity: 0.8;
  position: absolute;
  width: 100vw;
  height: 100vh;
  z-index: 0;
}

.content {
  position: absolute;
  z-index: 1;
  width: 100vw;
  height: 100vh;
}

.welcome {
  font: Bold 1rem Helvetica;
  color: #ffffff;
}

@media only screen and (max-width: 600px) {
  $width: 90%;
  .card {
    padding: 2rem;
    width: $width;
  }
  .signup {
    width: $width;
  }

  .forgot_pwd {
    text-align: center;
    margin-top: 1.5rem;
    margin-bottom: 0.5rem;
  }
}

@media only screen and (min-width: 600px) {
  $width: 40rem;
  .card {
    padding: 2rem 4rem 2rem 4rem;
    width: $width;
  }

  .signup {
    width: $width;
  }

  .forgot_pwd {
    text-align: left;
    margin-top: -1.5rem;
    margin-bottom: 2rem;
  }
}

.card {
  margin-top: 2.5rem;
}

.signup {
  font: Bold 1rem Helvetica;
  text-align: left;
  color: #ffffff;
}

.forgot_pwd {
  width: 100%;
  font: Regular 0.8rem Helvetica;
  color: #777777;
  display: none;
}

.card-title {
  font: Bold 1.5rem Helvetica;
  color: #333333;
}

.label {
  font: Medium 1rem Noto Sans CJK JP;
  color: #111111;
}

.link {
  cursor: pointer;
  color: #3794e3;
  text-decoration: underline;
}

.checkbox {
  margin-top: -30px;
  margin-left: auto;
  color: #979797;
  font: SemiBold 14px/18px Muli;
}

.btn {
  width: 200px;
}
</style>
